import { configRefs } from '@utils/constants';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';
import { opgavekompleksetTaskSchema } from '../schemas/opgavekomplekset/tasks/_task-data.js';

async function fetchOpgavekompleksetTasks(descriptors) {
  const url = `${await configRefs.apis.opgavekomplekset.get()}/api/player/tasks`;
  const res = await fetch(...authenticateComponentFrameworkRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      sequences: descriptors.map(descriptor => {
        switch (descriptor.type) {
          case "folder":
            return {
              type: "folders",
              ids: [{
                id: descriptor.id,
                taskCount: descriptor.tasksToTake
              }]
            };
          case "stack":
            return {
              type: "tasks",
              ids: descriptor.tasks.map(it => it.id)
            };
          case "task":
            return {
              type: "tasks",
              ids: [descriptor.id]
            };
        }
      })
    })
  }));
  if (res.status < 200 || res.status >= 300) {
    const descriptorIds = descriptors.flatMap(descriptor => Array.isArray(descriptor) ? descriptor.map(it => it.id) : [descriptor.id]);
    throw new Error(`fetchOpgavekompleksetTasks(): Failed to fetch tasks for descriptors: ${descriptorIds.join(", ")}\n\n${await res.text()}`);
  }
  const tasks = await res.json();
  return tasks.map(it => opgavekompleksetTaskSchema.parse(it));
}

export { fetchOpgavekompleksetTasks };
//# sourceMappingURL=request.fetch-opgavekomplekset-tasks.js.map
